<template lang="pug">
.div
    #header-box(style)
        #logo-box
            img.logo(src='../assets/car-logo.png', alt='')
        #user-box(v-if='usuario.autenticado')
            .userdata
                b.username {{ usuario.nome }}
                .userperfil {{ usuario.perfil }}
            .loggout.mdi.mdi-exit-to-app(@click='sairAnalisePrada()')
</template>

<script>
export default {
    name: 'HeaderComponent',

    data() {
        return {
            usuario: this.$eu(),
        };
    },
    methods: {
        sairAnalisePrada() {
            window.location.href = process.env.VUE_APP_SICAR_URL;
        }
    }
};
</script>

<style scoped>
#header-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    background-color: var(--primary-gray) !important;

    height: 110px;
    width: 100%;
}

.logo {
    height: 110px;
    padding: 10px 0 10px 35px;
    background-size: contain;
}

#user-box {
    display: flex;
    height: 91px !important;
}

.userdata {
    text-align: start;
    padding: 5px;
}

.loggout {
    padding: 5px 35px 5px 5px !important;
    color: var(--primary-black) !important;
    font-size: 30px !important;
    cursor: pointer !important;
    font-size: 32px;
}
</style>
